module.exports = __webpack_public_path__ + "assets/img/report-pp-btn-bg.3ce960db.png";